module.exports = __webpack_public_path__ + "img/dashmovelogo.ac897010.png";